import { atom } from 'jotai';

import type { Plan } from '@/fixtures/plans';

/**
 * Controls the global UpgradePlanModal mounted in `Modals/Account/index.tsx`,
 * used by `useUpsellModal` to drive asset-page paywall upgrades.
 *
 * Distinct from `@/pages/pricing/atoms#upgradePlanModalPlanAtom`, which
 * controls the pricing-page-local UpgradePlanModal instance.
 */
export const assetPaywallUpgradeModalOpenAtom = atom(false);

export const assetPaywallUpgradeModalPlanAtom = atom<Plan['name']>('Creator');
